import { render, staticRenderFns } from "./AffiliateContestTab.vue?vue&type=template&id=3cec806e&"
import script from "./AffiliateContestTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AffiliateContestTab.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AffiliateContestTab.vue?vue&type=style&index=0&id=3cec806e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports